import { GridColDef } from "@mui/x-data-grid-premium";
import { renderDate } from "../../../formatting/dateFormat";
import { ExpandButton } from "../../../components/datagrid/components/ExpandButton";

export const columns: GridColDef[] = [
  {
    field: "expand",
    headerName: "",
    description: "",
    width: 50,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      return <ExpandButton rowId={params.id} />;
    },
  },
  {
    field: "amazon_listings.msku",
    headerName: "MSKU",
    description: "Merchant SKU",
    valueGetter: (value, row) => row.amazon_listings?.msku,
  },
  {
    field: "product.product_title",
    headerName: "Title",
    description: "Product Title",
    valueGetter: (value, row) => row.product?.product_title,
  },
  {
    field: "amazon_listings.asin",
    headerName: "ASIN",
    description: "Amazon Standard Identification Number",
    valueGetter: (value, row) => row.amazon_listings?.asin,
  },
  {
    field: "amazon_listings.fnsku",
    headerName: "FNSKU",
    description: "Fulfillment Network SKU",
    valueGetter: (value, row) => row.amazon_listings?.fnsku,
  },
  {
    field: "amazon_listings.stock",
    headerName: "Stock",
    description: "Current Stock Level",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.stock,
  },
  {
    field: "amazon_listings.status",
    headerName: "Status",
    description: "Listing Status",
    valueGetter: (value, row) => row.amazon_listings?.status,
  },
  {
    field: "amazon_listings.last_order_price",
    headerName: "Last Order Price",
    description: "Price of Last Order",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.last_order_price,
  },
  {
    field: "amazon_listings.last_order_qty",
    headerName: "Last Order Qty",
    description: "Quantity of Last Order",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.last_order_qty,
  },
  {
    field: "amazon_listings.inbound_inventory",
    headerName: "Inbound Inventory",
    description: "Inbound Inventory Count",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.inbound_inventory,
  },
  {
    field: "amazon_listings.ship_stock",
    headerName: "Ship Stock",
    description: "Shippable Stock",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.ship_stock,
  },
  {
    field: "amazon_listings.inv_age_271_to_365",
    headerName: "Aged 271-365 Days",
    description: "Inventory Aged 271-365 Days",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.inv_age_271_to_365,
  },
  {
    field: "amazon_listings.alert",
    headerName: "Alert",
    description: "Listing Alert Status",
    valueGetter: (value, row) => row.amazon_listings?.alert,
  },
  {
    field: "amazon_listings.fba_sell_through",
    headerName: "FBA Sell Through",
    description: "FBA Sell Through Rate",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.fba_sell_through,
  },
  {
    field: "product.total_sales",
    headerName: "Total Sales",
    description: "Total Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.total_sales,
  },
  {
    field: "product.90_day_sales",
    headerName: "90 Day Sales",
    description: "90 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.["90_day_sales"],
  },
  {
    field: "product.30_day_sales",
    headerName: "30 Day Sales",
    description: "30 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.["30_day_sales"],
  },
  {
    field: "product.7_day_sales",
    headerName: "7 Day Sales",
    description: "7 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.["7_day_sales"],
  },
  {
    field: "amazon_listings.price",
    headerName: "Listing Price",
    description: "Current Listing Price",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.price,
  },
  {
    field: "amazon_listings.30_day_profit",
    headerName: "30 Day Profit",
    description: "30 Day Profit",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.["30_day_profit"],
  },
  {
    field: "amazon_listings.msku_total_sales",
    headerName: "Listing Total Sales",
    description: "Total sales for this specific MSKU listing.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.msku_total_sales,
  },
  {
    field: "amazon_listings.asin_total_sales",
    headerName: "ASIN Total Sales",
    description: "Total sales across all listings on this ASIN.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.asin_total_sales,
  },
  {
    field: "amazon_listings.msku_365_day_sales",
    headerName: "Listing 365 Day Sales",
    description: "365 day sales for this specific MSKU listing.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.msku_365_day_sales,
  },
  {
    field: "amazon_listings.asin_365_day_sales",
    headerName: "ASIN 365 Day Sales",
    description: "365 day sales across all listings on this ASIN.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.asin_365_day_sales,
  },
  {
    field: "amazon_listings.msku_90_day_sales",
    headerName: "Listing 90 Day Sales",
    description: "90 day sales for this specific MSKU listing.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.msku_90_day_sales,
  },
  {
    field: "amazon_listings.asin_90_day_sales",
    headerName: "ASIN 90 Day Sales",
    description: "90 day sales across all listings on this ASIN.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.asin_90_day_sales,
  },
  {
    field: "amazon_listings.msku_30_day_sales",
    headerName: "Listing 30 Day Sales",
    description: "30 day sales for this specific MSKU listing.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.msku_30_day_sales,
  },
  {
    field: "amazon_listings.asin_30_day_sales",
    headerName: "ASIN 30 Day Sales",
    description: "30 day sales across all listings on this ASIN.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.asin_30_day_sales,
  },
  {
    field: "amazon_listings.msku_7_day_sales",
    headerName: "Listing 7 Day Sales",
    description: "7 day sales for this specific MSKU listing.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.msku_7_day_sales,
  },
  {
    field: "amazon_listings.asin_7_day_sales",
    headerName: "ASIN 7 Day Sales",
    description: "7 day sales across all listings on this ASIN.",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.asin_7_day_sales,
  },
  {
    field: "amazon_product_pricing_info.sales_rank",
    headerName: "Sales Rank",
    description: "Product Sales Rank",
    type: "number",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.sales_rank,
  },
  {
    field: "amazon_product_pricing_info.product_category",
    headerName: "Category",
    description: "Product Category",
    valueGetter: (value, row) =>
      row.amazon_product_pricing_info?.product_category,
  },
  {
    field: "amazon_product_pricing_info.holds_buy_box",
    headerName: "Holds Buy Box",
    description: "Holds Buy Box",
    type: "boolean",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.holds_buy_box,
  },
  {
    field: "amazon_product_pricing_info.buy_box_price",
    headerName: "Buy Box Price",
    description: "Buy Box Price",
    type: "number",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.buy_box_price,
  },
  {
    field: "amazon_product_pricing_info.buy_box_info",
    headerName: "Buy Box Info",
    description: "Buy Box Information",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.buy_box_info,
  },
  {
    field: "amazon_listings.purchasable_stock",
    headerName: "Purchasable Stock",
    description: "Purchasable Stock Count",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.purchasable_stock,
  },
  {
    field: "amazon_listings.last_non_cancelled_order_timestamp",
    headerName: "Last Order Date",
    description: "Last Non-Cancelled Order Timestamp",
    type: "dateTime",
    valueGetter: (value, row) =>
      row.amazon_listings?.last_non_cancelled_order_timestamp,
    valueFormatter: (value) => renderDate(value),
  },
];
